import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { RenderContext3D } from "../render/RenderContext3D";
export class SceneRenderManager {
    constructor() {
        this._sceneManagerOBJ = Laya3DRender.Render3DPassFactory.createSceneRenderManager();
    }
    get list() {
        return this._sceneManagerOBJ.list;
    }
    set list(value) {
        this._sceneManagerOBJ.list = value;
    }
    addRenderObject(object) {
        this._sceneManagerOBJ.addRenderObject(object);
    }
    removeRenderObject(object) {
        this._sceneManagerOBJ.removeRenderObject(object);
    }
    removeMotionObject(object) {
        this._sceneManagerOBJ.removeMotionObject(object);
    }
    updateMotionObjects() {
        this._sceneManagerOBJ.updateMotionObjects();
    }
    renderUpdate() {
        var context = RenderContext3D._instance;
        let lists = this._sceneManagerOBJ.list.elements;
        for (let i = 0, n = this.list.length; i < n; i++) {
            lists[i].renderUpdate(context);
        }
    }
    addMotionObject(object) {
        this._sceneManagerOBJ.addMotionObject(object);
    }
    destroy() {
        this._sceneManagerOBJ.destroy();
    }
}
